// extracted by mini-css-extract-plugin
module.exports = {"container":"Privacy_container__3Oitd","title":"Privacy_title__1iXPj","content":"Privacy_content__2kYKS"};